import {CommonModule} from '@angular/common';
import {Component, inject, Input} from '@angular/core';
import {
    InventoryClient,
    SLAScoreQuery,
    SLATrendingQuery,
    SLAScoreExportQuery,
    IMyScoreShiftQuery,
    ITrendingQuery
} from "@services";
import {ScoreDashboardComponent} from "../../../../components/library/score-dashboard/score-dashboard.component";

@Component({
    selector: 'app-sla-score',
    standalone: true,
    imports: [CommonModule, ScoreDashboardComponent],
    templateUrl: './sla-score.component.html'
})
export class SLAScoreComponent {
    private inventoryClient = inject(InventoryClient);

    @Input() storageTypeCode?: string;
    @Input() title: string = 'SLA Score';

    loadScoreData = (query: IMyScoreShiftQuery) => {
        let slaQuery = new SLAScoreQuery();
        slaQuery.init({...query, storageTypeCode: this.storageTypeCode});
        return this.inventoryClient.getSLAScore(slaQuery);
    }

    loadTrendingData = (query: ITrendingQuery) => {
        let slaQuery = new SLATrendingQuery();
        slaQuery.init({...query, storageTypeCode: this.storageTypeCode});
        return this.inventoryClient.getSLATrending(slaQuery);
    }

    exportData = (from: Date, to: Date) => {
        const query = new SLAScoreExportQuery({from, to, storageTypeCode: this.storageTypeCode});
        return this.inventoryClient.exportSLAScore(query);
    }
}
